import React, { useEffect } from 'react';
import rest from "../../rest";
import { Grid, FormControl, TextField, InputLabel, Select, Input, MenuItem, Chip } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import DateRangeIcon from '@material-ui/icons/DateRange';
import FilterListIcon from '@material-ui/icons/FilterList';
import GetRandomKey from '../../components/general/genereRandomKey';
import ButtonStyled from '../../components/general/ButtonStyled';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';

const ActivitySearch = ({
  classesAccueil,
  recherche,
  handleChangeRechercher,
  selectDate,
  handleChangeDate,
  dateActivites,
  setDateActivites,
  selectcritere,
  handleChangeCritere,
  critere,
  setCritere,
  remiseAZero,
  hasRecherche
}) => {


  //  Requete pour le filtre Date
  const listDate = () => {
    try {
      rest.get("/activites/recuperationDatesDispo.json")
        .then((response) => {
          setDateActivites(
            Array.isArray(response?.data?.DateDispo)
              ? response.data.DateDispo
              : []
          );
        })
        .catch(() => {
          console.error("/activites/recuperationDatesDispo.json Activity");
        });
    } catch (error) {
      console.error("/activites/recuperationDatesDispo.json Activity catch");
    }
  };

  //  Requete pour le filtre Critere
  const listCritere = () => {
    try {
      rest.get("/parametres/getCaracteristique.json")
        .then((response) => {
          setCritere(Array.isArray(response?.data) ? response.data : []);
        })
        .catch(() => {
          console.error("/activites/recuperationDatesDispo.json Activity listCritere");
        });
    } catch (error) {
      console.error("/activites/recuperationDatesDispo.json Activity listCritere catch");
    }
  };



  useEffect(() => {
    listDate();
    listCritere();
    // eslint-disable-next-line
  }, []);


  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={4}>
        <FormControl className={classesAccueil.filtre}>
          <TextField
            id="filled-basic"
            label="Recherche"
            value={recherche}
            onChange={handleChangeRechercher}
          />
          <InputLabel style={{ marginInlineStart: "95%" }}>
            <SearchIcon />
          </InputLabel>
        </FormControl>
      </Grid>
      <Grid item xs={6} md={4}>
        {/* Filtre Date */}
        <FormControl className={classesAccueil.filtre}>
          <InputLabel id="select-multiple">Dates</InputLabel>
          <Select
            labelId="select-multiple"
            id="select-multiple"
            multiple
            value={selectDate}
            IconComponent={DateRangeIcon}
            onChange={handleChangeDate}
            input={<Input id="select-multiple" />}
            renderValue={(select) => (
              <div className={classesAccueil.chips}>
                {select &&
                  select.map((value) => (
                    <Chip
                      key={GetRandomKey(11)}
                      label={value}
                      color="primary"
                    />
                  ))}
              </div>
            )}
          >
            {dateActivites &&
              dateActivites.map((date) => (
                <MenuItem key={GetRandomKey(10)} value={date}>
                  {date}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} md={4}>
        {/* Filtre Autres critères */}
        <FormControl className={classesAccueil.filtre}>
          <InputLabel>Autres critères</InputLabel>
          <Select
            value={selectcritere}
            multiple
            IconComponent={FilterListIcon}
            onChange={handleChangeCritere}
            input={<Input />}
            renderValue={(select) => (
              <div className={classesAccueil.chips}>
                {critere?.length > 0 &&
                  critere.map((value) =>
                    select?.map(
                      (sel) =>
                        sel === value.ID && (
                          <Chip
                            key={GetRandomKey(12)}
                            label={value.Nom}
                            color="primary"
                          />
                        )
                    )
                  )}
              </div>
            )}
          >
            {critere?.length > 0 &&
              critere.map((value) => (
                <MenuItem key={GetRandomKey(8)} value={value.ID}>
                  {value.Nom}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
      {hasRecherche && <Grid item xs={12}>

        <ButtonStyled
          onClick={(_) => remiseAZero()}
          style={{ width: '100%', Height: '10px', padding: '3px' }}
          color='errorBtn'
          variant="contained"
        >
          <DoubleArrowIcon style={{transform: 'rotate(180deg)', marginRight: '20px'}} />{' Retour '}
        </ButtonStyled></Grid>}
    </Grid>
  );
};

export default ActivitySearch;
